import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-customer-utf-cancel-modal',
    templateUrl: './customer-utf-cancel-modal.component.html',
    styleUrls: ['./customer-utf-cancel-modal.component.scss'],
    standalone: false
})
export class CustomerUtfCancelModalComponent extends CfetBaseComponent {
  returnUrl = '';
  url = '';

  @Input() openModal: string;
  @Output() closeCancelModal = new EventEmitter<any>();

  constructor() {
    super();
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeCancelModal.emit('modalClose');
    }
  }

  cancelApplication(event, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrl(encodeURIComponent(this.url + '?fnStatus=eligible-pending'));
        } else {
          this.redirectUrl(encodeURIComponent(this.url + '&fnStatus=eligible-pending'));
        }
      } else {
        // Redirect to the plp page
        const url = environment.plp_page;
        this.redirectUrl(url + '&fnStatus=eligible-pending');
      }
    }
  }

  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }
}
